import { useBaseDeleteAccount } from '@/api/react-query'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/i18n/i18n-react'
import { useLogOut } from '@/providers/auth-provider'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import { useState } from 'react'

export const Route = createFileRoute('/delete-account')({
	component: DeleteAccountPage
})

function DeleteAccountPage() {
	const { L } = useI18n()
	const navigate = useNavigate()
	const logOut = useLogOut()
	const deleteAccount = useBaseDeleteAccount(true)
	const [step, setStep] = useState<'confirm' | 'final'>('confirm')
	const isFinal = step === 'final'

	const handleCancel = () => navigate({ to: '/' })

	const handleAction = () => {
		if (!isFinal) {
			setStep('final')
			return
		}
		deleteAccount.mutate(
			{},
			{
				onSuccess: result => {
					if (result.isSuccess) {
						logOut()
					} else {
						toast.error(L.Errors.Generic())
					}
				},
				onError: () => toast.error(L.Errors.Generic())
			}
		)
	}

	return (
		<div className='flex min-h-dvh flex-col items-center justify-center px-6'>
			<div className='flex w-full max-w-sm flex-col items-center gap-6 text-center'>
				<div className='bg-destructive/10 flex h-20 w-20 items-center justify-center rounded-full'>
					<Trash2 className='text-destructive h-10 w-10' />
				</div>

				<div className='flex flex-col gap-2'>
					<h1 className='text-xl font-semibold'>
						{isFinal ? L.Profile.DeleteAccountFinalConfirm() : L.Profile.DeleteAccountConfirm()}
					</h1>
					<p className='text-muted-foreground text-sm'>
						{isFinal ?
							L.Profile.DeleteAccountFinalConfirmMessage()
						:	L.Profile.DeleteAccountConfirmMessage()}
					</p>
				</div>

				<div className='flex w-full flex-col gap-3'>
					<Button
						variant='destructive'
						className='w-full'
						onClick={handleAction}
						isLoading={deleteAccount.isPending}
					>
						{L.Profile.DeleteAccountConfirmButton()}
					</Button>
					<Button variant='outline' className='w-full' onClick={handleCancel}>
						{L.Common.Actions.Cancel()}
					</Button>
				</div>
			</div>
		</div>
	)
}
